export enum AMPLITUDE_EVENTS {
  ADD_TO_CART = 'ADD_TO_CART',
  SELECT_VIEW_TYPE = 'SELECT_VIEW_TYPE',
  SELECT_FILTER = 'SELECT_FILTER',
  SELECT_CAR_CATEGORY = 'SELECT_CAR_CATEGORY',
  VIEW_CAR_CATEGORY_OPTIONS = 'VIEW_CAR_CATEGORY_OPTIONS',
  SELECT_CAR_VENDOR = 'SELECT_CAR_VENDOR',
  SELECT_VIEW_TRAVEL_QUOTE = 'SELECT_VIEW_TRAVEL_QUOTE',
  TRAVEL_SEAMLESS_LOGIN = 'TRAVEL_SEAMLESS_LOGIN',
  TRAVEL_SEAMLESS_AUTH_ERROR = 'TRAVEL_SEAMLESS_AUTH_ERROR',
  START_CHECKOUT = 'START_CHECKOUT',
  START_INTERMEDIARY_CHECKOUT = 'START_INTERMEDIARY_CHECKOUT',
  RESULT_CREATE_ORDER_BILLING = 'RESULT_CREATE_ORDER_BILLING',
  START_CHECKOUT_NOT_BILLING = 'START_CHECKOUT_NOT_BILLING',
  SELECT_VIEW_PAX_LIST = 'SELECT_VIEW_PAX_LIST',
  TRAVEL_DATE_RESTRICTED = 'TRAVEL_DATE_RESTRICTED',
  SELECT_TRAVEL_POPULAR_DESTINATIONS = 'SELECT_TRAVEL_POPULAR_DESTINATIONS',
  SELECT_ADD_PAX = 'SELECT_ADD_PAX',
  SELECT_EDIT_PAX = 'SELECT_EDIT_PAX',
  VIEW_TRAVEL_CROSS_SELLING_ASSISTANCE_MODAL = 'VIEW_TRAVEL_CROSS_SELLING_ASSISTANCE_MODAL'
}

export enum EVENT_SOURCE {
  TRAVEL_HOME = 'TRAVEL_HOME',
  RESULTS = 'RESULTS',
  DETAIL = 'DETAIL',
  MAP = 'MAP',
  LIST = 'LIST',
  TAG = 'TAG',
  RESERVATIONS = 'RESERVATIONS',
  BOOKING = 'BOOKING',
  CROSS_SELLING_HOTEL = 'CROSS_SELLING_HOTEL',
  CROSS_SELLING_ASSISTANCE = 'CROSS_SELLING_ASSISTANCE',
  OFFERS = 'OFFERS',
}
